import React from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { useState,useEffect } from 'react';
import axios from 'axios';

const Ewallet = () => {

  const [Wallet, setWallet] = useState([]);
  
  const getWallet = async () => {
    try {
      const response = await axios.get("https://fakestoreapi.com/products?limit=10");
      const empData = response.data;
      setWallet(empData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getWallet();
  }, []);

  return (
    <div>
            
    <Container>
                       
      <div className='container'>
          <div className='row '>
              <div className='col-lg-12 '>
                  <div className='row ' style={{display:"flex"}} >
                  </div>
                  <div className="row ">
                      <div className="col-lg-6 mt-4  ">
                          
                      </div>
                  </div>
           
                  <div className="row mt-4">
                  <div className="col-lg-12">


                      <div className="card">
                      <div className="card-header"  style={{backgroundColor:"rgb(0,156,216)",color:'white'}}>
                          <h4> E-Wallet</h4>
                      </div>
                     
                      <div className="card-body">
                          
                          <form>
                          <div className="card-body">
                              <div className='table-responsive'>
                              <table className="table table-bordered">
        
                              <thead>
                                  <tr>
                                  <th scope="col">Sl No</th>
                                  <th scope="col">Date</th>
                                  <th scope="col">Name</th>
                                  <th scope="col">ID</th>
                                  <th scope="col">Transfer Amount Request</th>    
                                  <th scope="col">Action</th>
                                 
                                  
                                 
                                  </tr>
                              </thead>
                              

                              <tbody>
                              {
                                Wallet.map((product, index) => (
                                  <tr key={index}>
                                    <td>{product.id}</td>
                                    <td>{product.title}</td>
                                    <td>{product.price}</td>
                                   
                                    <td>{product.title}</td>
                                    <td>{product.price}</td>
                                   
                                    <td>
                                    <button className='btn btn-primary'>Edit</button>
                                    <button className='btn btn-danger'>Delete</button>
                                    </td>
                                  </tr>
                                ))
                                }
                              </tbody>


                              </table>
                              <nav aria-label="...">
<ul class="pagination">
  <li class="page-item disabled">
    <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
  </li>
  <li class="page-item"><a class="page-link" href="#">1</a></li>
  <li class="page-item active" aria-current="page">
    <a class="page-link" href="#">2</a>
  </li>
  <li class="page-item"><a class="page-link" href="#">3</a></li>
  <li class="page-item">
    <a class="page-link" href="#">Next</a>
  </li>
</ul>
</nav>
                              </div>
                              
                          </div>
                          {/* /.card-body */}
                          </form>
                      </div>
                      </div>
                  </div>
                  </div>






              

                

              </div>

          </div>

      
      </div>
      
    
    
  </Container>

          

    </div>
  )
}

export default Ewallet;